// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"dffd04ae","425":"864a8080","510":"02bd5465","532":"414d80e7","633":"bc2400e1","634":"827b0fcc","922":"4c6a9bd1","937":"abc95035","972":"ff2469a6"}[chunkId] + ".chunk.js";
};